import React from 'react'
import { Card, CardContent, CardHeader } from '@/shared/ui'
import type { RewardsAccountExchangeLink } from '../types'
import RewardsLinkStatusBadge from './RewardsLinkStatusBadge'

function formatIso(iso?: string | null): string {
  if (!iso) return '—'
  try {
    const d = new Date(iso)
    return d.toLocaleString('pt-BR')
  } catch {
    return iso
  }
}

export default function RewardsLinksCard({ links }: { links: RewardsAccountExchangeLink[] }) {
  return (
    <Card className="border-0 shadow">
      <CardHeader className="border-b-0 text-base font-semibold">Integração com corretoras</CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-foreground/70">
          O Rewards depende da vinculação da sua conta na corretora ao programa do Cripto Alert (configurado pelo MASTER).
        </p>

        {links.length === 0 ? (
          <div className="rounded-lg bg-muted/30 p-4 text-sm text-foreground/70">Nenhuma corretora vinculada ainda.</div>
        ) : (
          <div className="space-y-3">
            {links.map((l) => (
              <div key={l.id} className="rounded-lg bg-muted/30 p-4">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div className="text-sm font-medium">{l.exchange.toUpperCase()}</div>
                  <RewardsLinkStatusBadge status={l.status} />
                </div>

                <div className="mt-3 grid gap-3 text-sm md:grid-cols-2">
                  <div>
                    <div className="text-xs text-foreground/60">UID/ID</div>
                    <div className="font-medium">{l.exchange_user_id}</div>
                  </div>
                  <div>
                    <div className="text-xs text-foreground/60">Última sincronização</div>
                    <div className="font-medium">{formatIso(l.last_sync_at)}</div>
                  </div>
                  <div>
                    <div className="text-xs text-foreground/60">Vinculado em</div>
                    <div className="font-medium">{formatIso(l.linked_at)}</div>
                  </div>
                  <div>
                    <div className="text-xs text-foreground/60">Erro</div>
                    <div className="break-words font-medium">{l.last_error || '—'}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

